import { gql } from "@apollo/client";


export const AJUSTAR_FECHA_HASTA_DIAS_CORRIDO = gql`
    mutation ajustarFechaHastaDiasCorrido( $idEvaluacion: Int!){
        ajustarFechaHastaDiasCorrido( idEvaluacion: $idEvaluacion)
 }
`;